module.exports = __webpack_public_path__ + "img/IMG_1966.95a8d915.jpg";